import React from 'react'
import PropTypes from 'prop-types'
import { Field } from '../../'

/* doc
---
title: ButtonGroup
name: ButtonGroup
category: React - Bulma
parent: Button
---

A `ButtonGroup` component based on Bulma `.button-group`. This groups together
multiple buttons. add `isSpaceless` to remove space between buttons.

Each `Button` component should be wrapped with a `ButtonGroupItem` component.

See [Bulma Documentation](http://bulma.io/documentation/elements/button/#button-group) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

### Props
| Prop Name       | Description                                   |Type            | Default Value             | Required?     |
|-----------------|-----------------------------------------------|----------------|---------------------------|---------------|
| isSpaceless     | Removes space btween buttons.                 | boolean        | false                     | no            |

```html_example
  <ButtonGroup isSpaceless>
    <ButtonGroupItem>
      <PrimaryButton>...</PrimaryButton>
    <ButtonGroupItem>
    <ButtonGroupItem>
      <ErrorButton>...</ErrorButton>
    <ButtonGroupItem>
  </ButtonGroup>
```
*/
function ButtonGroup(props) {
  const { children, isSpaceless, ...rest } = props

  return (
    <Field
      {...rest}
      hasAddons={isSpaceless}
      isGrouped={!isSpaceless}
    >
      {children}
    </Field>
  )
}

ButtonGroup.defaultProps = {
  isSpaceless: false,
}

ButtonGroup.propTypes = {
  // Removes space between buttons.
  isSpaceless: PropTypes.bool,
}

export default ButtonGroup
